/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { ActivityIndicator, StyleSheet, Text, View, type StyleProp, type ViewStyle } from 'react-native';
import { spacing, ticketColors } from '../../shared/theme/public-api';
import { settingsStyles } from '../../settings/screens/settingsScreen.styles';

type Props = {
  label?: string;
  style?: StyleProp<ViewStyle>;
};

/** Loader dentro del shell de pantalla; siempre pinta fondo oscuro. */
export function ShellScreenLoading({ label = 'Cargando…', style }: Props) {
  return (
    <View style={[styles.root, style]} accessibilityLabel={label}>
      <ActivityIndicator size="large" color={ticketColors.gold} />
      {label ? <Text style={settingsStyles.caption}>{label}</Text> : null}
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    alignSelf: 'stretch',
    backgroundColor: ticketColors.bg,
    justifyContent: 'center',
    alignItems: 'center',
    gap: spacing.md,
    paddingVertical: spacing.xxl,
    paddingHorizontal: spacing.lg,
    minHeight: 160,
  },
});
